import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/reports/payments-obligations`

export default (queryParams = {}) =>
  http.get(`${api}`, { params: { ...queryParams } })
